const STORAGE_KEY = 'fgt_cookie_consent_v1';
const ID_KEY = 'fgt_consent_id';
const PENDING_KEY = 'fgt_consent_log_pending';
const COOKIE_NAME = 'fgt_cookie_consent';
export const POLICY_VERSION = '2026-09';
const SIX_MONTHS_SECONDS = 60 * 60 * 24 * 183;

export function hasCategoryConsent(category) {
  if (category === 'necessary') return true;
  return false;
}

export function clearLegacyIubendaCookies() {
  if (typeof document === 'undefined') return;
  document.cookie.split(';').forEach((part) => {
    const name = part.split('=')[0].trim();
    if (!name.startsWith('_iub')) return;
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
  });
}

export function loadConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.policyVersion !== POLICY_VERSION) return null;
    if (data.choice === 'rejected' && isOlderThanSixMonths(data.decidedAt)) {
      localStorage.removeItem(STORAGE_KEY);
      clearConsentCookie();
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function saveConsent({ choice }) {
  const record = {
    consentId: getConsentId(),
    policyVersion: POLICY_VERSION,
    necessary: true,
    choice,
    decidedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  writeConsentCookie(record);
  window.dispatchEvent(new CustomEvent('fgt-cookie-consent', { detail: record }));
  return record;
}

export function sendConsentLog(record) {
  const payload = {
    consent_id: record.consentId,
    choice: record.choice,
    policy_version: record.policyVersion,
  };
  return fetch('/api/cookie_consent.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).then((response) => {
    if (!response.ok) throw new Error('consent log');
    localStorage.removeItem(PENDING_KEY);
  }).catch(() => {
    try {
      localStorage.setItem(PENDING_KEY, JSON.stringify(payload));
    } catch {
      // il banner resta utilizzabile anche se il registro non risponde
    }
  });
}

export function retryPendingConsentLog() {
  try {
    const raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return;
    const payload = JSON.parse(raw);
    if (!payload?.consent_id || !payload?.choice) return;
    sendConsentLog({
      consentId: payload.consent_id,
      choice: payload.choice,
      policyVersion: payload.policy_version,
    });
  } catch {
    localStorage.removeItem(PENDING_KEY);
  }
}

function getConsentId() {
  try {
    const existing = localStorage.getItem(ID_KEY);
    if (existing) return existing;
    const id = createConsentId();
    localStorage.setItem(ID_KEY, id);
    return id;
  } catch {
    return createConsentId();
  }
}

function createConsentId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const rand = Math.floor(Math.random() * 16);
    const value = char === 'x' ? rand : ((rand % 4) + 8);
    return value.toString(16);
  });
}

function isOlderThanSixMonths(iso) {
  const decided = new Date(iso);
  if (Number.isNaN(decided.getTime())) return true;
  const limit = new Date(decided);
  limit.setMonth(limit.getMonth() + 6);
  return new Date() > limit;
}

function writeConsentCookie(record) {
  const payload = encodeURIComponent(JSON.stringify({
    c: record.choice,
    v: record.policyVersion,
  }));
  document.cookie = `${COOKIE_NAME}=${payload}; path=/; max-age=${SIX_MONTHS_SECONDS}; SameSite=Lax`;
}

function clearConsentCookie() {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
}
